import { render, staticRenderFns } from "./LayerTabComponent.vue?vue&type=template&id=6d4ca452&scoped=true"
import script from "./LayerTabComponent.vue?vue&type=script&lang=js"
export * from "./LayerTabComponent.vue?vue&type=script&lang=js"
import style0 from "./LayerTabComponent.vue?vue&type=style&index=0&id=6d4ca452&prod&lang=scss"
import style1 from "./LayerTabComponent.vue?vue&type=style&index=1&id=6d4ca452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4ca452",
  null
  
)

export default component.exports